import React, { useCallback, useContext, useEffect, useState } from 'react';
import styles from './ManagementCompanyForm.module.scss';
import { useSelector } from 'react-redux';
import { ReactComponent as CompanyMenedgerIcon } from '../../../../../resource/CompanyMenedgerIcon.svg';
import { generateExpWithNum } from '../../../utils/generateExpWithNum';
import { declensions } from '../../../constants/declensions';
import { HousesContext } from '../../../pages/ChangingAllPage/Provider';

const ManagementCompanyList = ({ company, subtitle }) => {
  return (
    <div className={styles.companyList}>
      <CompanyMenedgerIcon style={{ flex: '0 0 auto' }} />
      <div>
        <div className={styles.company}>{company?.name}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
    </div>
  );
};

const ManagementCompanyForm = () => {
  const houses = useContext(HousesContext);

  const getSelector = (key) => (state) => state.housingStockStore[key];
  const currentCompany = useSelector(getSelector('currentCompany'));

  const generateContent = (count, declensions) =>
    generateExpWithNum(count, declensions);

  const declensionsMap = {
    houses: declensions.houses,
    clients: declensions.registeredResidents,
  };

  const getSubtitle = useCallback(
    (houses) => {
      const init = {
        houses: houses.length,
        clients: 0,
      };

      const counts = houses.reduce((acc, house) => {
        if (house.clientCount) {
          acc.clients += house.clientCount;
        }
        return acc;
      }, init);

      const subtitle = Object.entries(counts).reduce((acc, [key, value]) => {
        if (acc === '') {
          return generateContent(value, declensionsMap[key]);
        }

        return `${acc} / ${generateContent(value, declensionsMap[key])}`;
      }, '');

      return subtitle;
    },
    [declensionsMap]
  );

  const [subtitle, setSubtitle] = useState('');

  useEffect(() => {
    let newSubtitle = '';

    if (houses?.length > 0) {
      newSubtitle = getSubtitle(houses);
    }

    setSubtitle(newSubtitle);
  }, [houses, getSubtitle]);

  return (
    <div className={styles.conteiner}>
      <div className={styles.header}>
        <h3 className={styles.title}>Управляющая компания</h3>
      </div>
      <ManagementCompanyList
        subtitle={subtitle}
        company={currentCompany}
      />
    </div>
  );
};

export default ManagementCompanyForm;
